import * as Yup from "yup";

export const SubmitPollSchema = Yup.object({

    poll_option: Yup.string().required("Choose One Option"),
});